r<template>
  <div v-if="model">
    <rkm-area no-margin-top title="Filtros" type="fieldset">
      <rkm-form ref="RkmForm" show-legend>
        <rkm-row>
          <rkm-col cols="4">
            <rkm-form-date-picker
              range
              :range-inline="false"
              start-label="Período de"
              end-label="Até"
              v-model="model.periodo"
              :start-validations="validations.periodo.start"
              :end-validations="validations.periodo.end"
            />
          </rkm-col>
          <rkm-col cols="4">
            <rkm-form-select
              show-default-option
              default-option-text="TODOS"
              label="Município"
              :options="form.municipios"
              v-model="model.municipio"
              @change="getMotoristas"
              text-field="nome"
              value-field="id"
            />
          </rkm-col>
          <rkm-col cols="4">
            <rkm-form-select
              show-default-option
              default-option-text="TODOS"
              :options="form.motoristas"
              v-model="model.motorista"
              @change="getDestinos"
              label="Motorista"
              text-field="nome"
              value-field="id"
            />
          </rkm-col>
        </rkm-row>
        <rkm-row>
          <rkm-col cols="4">
            <rkm-form-select
              show-default-option
              default-option-text="TODOS"
              :options="form.destinos"
              v-model="model.destino"
              label="Destino"
              text-field="descricao"
              value-field="id"
            />
          </rkm-col>
          <rkm-col cols="4">
            <rkm-form-select
              show-default-option
              default-option-text="TODOS"
              :options="form.status"
              v-model="model.status"
              label="Status"
              text-field="descricao"
              value-field="id"
            />
          </rkm-col>
          <rkm-col>
            <rkm-button
              :label="false"
              color="primary"
              @click="$refs.RkmForm.validate(search)"
              >Buscar</rkm-button
            >
            <rkm-button :label="false" @click="reset">Limpar</rkm-button>
          </rkm-col>
        </rkm-row>
      </rkm-form>
    </rkm-area>

    <rkm-area no-margin-top title="Resultado" v-if="mostraAreaResultado">
      <template v-slot:trailing>
        <rkm-dropdown
          class="mr-2"
          color="primary"
          cols="1"
          menu-class="auto-scroll"
          no-caret
          small
          title="Colunas"
          v-rkm-tooltip.hover
        >
          <template v-slot:button-content>
            <rkm-icon icon="columns" />
          </template>

          <rkm-form-checkbox
            @change="selectAll"
            class="mx-2"
            v-model="selectedAll"
            :indeterminate="indeterminate"
          >
            Todas
          </rkm-form-checkbox>

          <rkm-form-checkbox-group
            :options="optionalColumns"
            class="mx-2"
            stacked
            text-field="label"
            v-model="selectedCols"
            value-field="key"
          />
        </rkm-dropdown>
        <rkm-button
          :disabled="items.length === 0"
          @click="print"
          color="info"
          small
          title="Imprimir"
        >
          <rkm-icon icon="print" />
        </rkm-button>

        <rkm-button
          :disabled="items.length === 0"
          @click="exportTo"
          color="info"
          small
          title="Exportar"
        >
          <rkm-icon icon="file-export" />
        </rkm-button>
      </template>

      <rkm-table
        :fields="fields"
        :items="items"
        sort-by="agendar.data"
        sort-desc
      >
        <template v-slot:(data)="{ item }">
            {{ item.data || formatDate }}
        </template>
      </rkm-table>
    </rkm-area>

    <rkm-area
      title="Totais"
      type="fieldset"
      no-margin-top
      v-if="mostraAreaResultado"
    >
      <rkm-row>
        <rkm-col col="auto">
          Agendado(s)
          <rkm-alert color="secondary">
            <strong>
              {{ totalizadores.agendado }}
            </strong>
          </rkm-alert>
        </rkm-col>
        <rkm-col col="auto">
          Cancelado(s)
          <rkm-alert color="secondary">
            <strong>
              {{ totalizadores.cancelado }}
            </strong>
          </rkm-alert>
        </rkm-col>
        <rkm-col col="auto">
          Falta(s)
          <rkm-alert color="secondary">
            <strong>
              {{ totalizadores.faltou }}
            </strong>
          </rkm-alert>
        </rkm-col>
        <rkm-col col="auto">
          Transportado(s)
          <rkm-alert color="secondary">
            <strong>
              {{ totalizadores.transportado }}
            </strong>
          </rkm-alert>
        </rkm-col>
        <rkm-col col="auto">
          Todos
          <rkm-alert color="secondary">
            <strong>
              {{ totalizadores.geral }}
            </strong>
          </rkm-alert>
        </rkm-col>
      </rkm-row>
    </rkm-area>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { repository, error, data, object, stringCase, file } from "@/mixins";
import moment from "moment";
import formats from '@/filters/formats'

export default {
    filters: {
        formatDate: formats.formatDate,
    },
  computed: {
    optionalColumns() {
      return this.columns.filter((c) => !(c.fixed || false));
    },
    fields() {
      return this.columns.filter(
        (c) => c.fixed || false || this.selectedCols.includes(c.key)
      );
    },
    validations() {
      return {
        periodo: {
          start: { required: true },
          end: { required: true },
        },
      };
    },
  },
  created() {
    this.repositories = {
      relatorioViagemData: this.getConectaSusRepository(
        "transportePaciente.relatorioViagemData"
      ),
      impressao: this.getConectaSusRepository("impressao.transportePaciente"),
      exportacao: this.getConectaSusRepository("exportacao.transportePaciente"),
      relatorioDeAplicacao: this.getConectaSusRepository("imunizacao.relatorioDeAplicacao")
    };
    this.load();
  },
  data() {
    return {
      model: null,
      form: null,
      items: [],
      selectedAll: true,
      indeterminate: false,
      mostraAreaResultado: false,
      totalizadores: [],
      selectedCols: [
        'motorista',
        'descricaoDestino',
      ],
      columns: [
        {
          key: "data",
          label: "Data",
          class: 'col-date',
          sortable: true,
          fixed: true,
        },
        {
          key: "municipio",
          label: "Município",
          sortable: true,
          fixed: true,
        },
        {
          key: "motorista",
          label: "Motorista",
          sortable: true,
        },
        {
          key: "descricaoDestino",
          label: "Destino",
          sortable: true,
        },
        {
            key: "protocolo",
            label: "Protocolo",
            fixed: true
        },
        {
          key: "descricaoStatus",
          label: "Status",
          sortable: true,
          fixed: true,
        },
      ],
    };
  },
  methods: {
    ...mapActions(["setLoading", "unsetLoading"]),
    load() {
      this.setLoading();
      this.repositories.relatorioViagemData
        .index()
        .then(({ data }) => {
          if (data.form) this.form = data.form;
          if (data.model) this.model = data.model;

          data.model.periodo.start = this.getDateObject(
            data.model.periodo.start
          );
          data.model.periodo.end = this.getDateObject(data.model.periodo.end);
        })
        .catch(this.handleError)
        .finally(() => this.unsetLoading());
    },
    handlePeriodo() {
      this.items = [];
      this.mostraAreaResultado = false;
      this.load();
    },
    search() {
      if (!this.model.periodo) {
        this.showAlert("Por favor selecione um período.", "Atenção");
        return;
      }
      this.setLoading();
      this.repositories.relatorioViagemData
        .list({
          start: moment(this.model.periodo.start).format("Y-M-D"),
          end: moment(this.model.periodo.end).format("Y-M-D"),
          municipio: this.model.municipio,
          motorista: this.model.motorista,
          destino: this.model.destino,
          status: this.model.status,
        })
        .then(({ data }) => {
          this.items = data.consulta;
          this.totalizadores = data.totalizadores;
          this.mostraAreaResultado = true;
        })
        .catch(this.handleError)
        .finally(() => this.unsetLoading());
    },
    getMunicipios() {
      if (this.model.periodo.start && this.model.periodo.end) {
        this.setLoading();
        this.repositories.relatorioViagemData
          .getMunicipios({
            start: moment(this.model.periodo.start).format("Y-M-D"),
            end: moment(this.model.periodo.end).format("Y-M-D"),
          })
          .then(({ data }) => {
            this.form.municipios = data;
            this.getMotoristas();
            this.getDestinos();
            this.getStatus();
          })
          .catch(this.handleError)
          .finally(() => this.unsetLoading());
      }
    },
    getMotoristas() {
      this.model.motorista = null;
      this.getDestinos();
      if (this.model.periodo.start && this.model.periodo.end) {
        this.setLoading();
        this.repositories.relatorioViagemData
          .getMotoristas({
            start: moment(this.model.periodo.start).format("Y-M-D"),
            end: moment(this.model.periodo.end).format("Y-M-D"),
            municipio: this.model.municipio,
          })
          .then(({ data }) => {
            this.form.motoristas = data;
          })
          .catch(this.handleError)
          .finally(() => this.unsetLoading());
      }
    },
    getDestinos() {
      this.model.destino = null;
      if (this.model.periodo.start && this.model.periodo.end) {
        this.setLoading();
        this.repositories.relatorioViagemData
          .getDestinos({
            start: moment(this.model.periodo.start).format("Y-M-D"),
            end: moment(this.model.periodo.end).format("Y-M-D"),
            municipio: this.model.municipio,
            motorista: this.model.motorista,
          })
          .then(({ data }) => {
            this.form.destinos = data;
          })
          .catch(this.handleError)
          .finally(() => this.unsetLoading());
      }
    },
    getStatus() {
      this.model.status = null;
      if (this.model.periodo.start && this.model.periodo.end) {
        this.setLoading();
        this.repositories.relatorioViagemData
          .getStatus()
          .then(({ data }) => {
            this.form.status = data;
          })
          .catch(this.handleError)
          .finally(() => this.unsetLoading());
      }
    },
    reset() {
      this.model.periodo.start = null;
      this.model.periodo.end = null;
      this.model.municipio = null;
      this.model.motorista = null;
      this.model.destino = null;
      this.model.status = null;
      this.form.municipios = null;
      this.form.motoristas = null;
      this.form.destinos = null;
      this.form.status = null;
      this.items = [];
      this.mostraAreaResultado = false;
    },
    print() {
      this.setLoading();
      this.repositories.impressao
        .relatorioViagemData(this.prepareDataWithColumns())
        .then(({ data, headers }) =>
          this.openFile(data, headers["content-type"])
        )
        .catch(this.handleError)
        .finally(() => this.unsetLoading());
    },
    exportTo() {
      this.setLoading();
      this.repositories.exportacao
        .relatorioViagemData(this.prepareDataWithColumns())
        .then(({ data, headers }) =>
          this.openFile(data, headers["content-type"])
        )
        .catch(this.handleError)
        .finally(() => this.unsetLoading());
    },
    prepareDataWithColumns() {
      const data = this.prepareData();
      data.selectedCols = this.fields.map((f) => {
        return {
          key: this.camelToSnake(f.key),
          label: f.label,
          class: f.class,
        };
      });
      return data;
    },
    prepareData() {
      const data = this.clone(this.model);
      data.start = moment(data.periodo.start).format("Y-M-D");
      data.end = moment(data.periodo.end).format("Y-M-D");
      return this.camelObjectKeysToSnakeRecursive(data);
    },
    selectAll(selected) {
      this.selectedCols = selected
        ? this.optionalColumns.map((c) => c.key)
        : [];
    },
  },
  mixins: [repository, error, data, object, stringCase, file],
  watch: {
    selectedCols(newValue) {
      this.selectedAll =
        newValue.length > 0 && newValue.length == this.optionalColumns.length;
      this.indeterminate =
        newValue.length > 0 && newValue.length != this.optionalColumns.length;
    },
    "model.periodo.start"() {
      if (this.model.periodo.start && this.model.periodo.end) {
        this.getMunicipios();
      }
    },
    "model.periodo.end"() {
      if (this.model.periodo.start && this.model.periodo.end) {
        this.getMunicipios();
      }
    },
  },
};
</script>
